import { type FC } from 'react';
import { useDisclosure, IconButton, Tooltip } from '@chakra-ui/react';
import SeeSomethingWrong from './SeeSomethingWrong';
import { ReactComponent as SeeSomethingWrongIcon } from '../../../../assets/svg/SeeSomethingWrongIcon.svg';
import { translate } from '../../../../constants/translation';
import { type VesselViewModel, type Page } from '../../../../types';
import { type Timestamp } from '../../../../services/Timestamp';

interface IncorrectInformationProps {
  page: Page;
  vessel: VesselViewModel;
  timestamp: Timestamp;
  timezone: string;
}

const IncorrectInformation: FC<IncorrectInformationProps> = ({ page, vessel, timestamp, timezone }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Tooltip placement="bottom-start" label={translate('MODAL_BTN')}>
        <IconButton
          variant="secondary"
          icon={<SeeSomethingWrongIcon />}
          aria-label={translate('MODAL_BTN')}
          onClick={onOpen}
        />
      </Tooltip>
      <SeeSomethingWrong
        isOpen={isOpen}
        vessel={vessel}
        onModalClose={onClose}
        page={page}
        timestamp={timestamp}
        timezone={timezone}
      />
    </>
  );
};
export default IncorrectInformation;
